export const categoryTabs = {
  "sole-proprietor": ["personal", "business", "kyc", "aml"],
  "public-limited-liability-company": [
    "personal",
    "business",
    "shareholders",
    "directors",
    "kyc",
    "aml",
  ],
  "private-limited-liability-company": [
    "personal",
    "business",
    "directors",
    "shareholders",
    "kyc",
    "aml",
  ],
  "non-government-organization": [
    "personal",
    "business",
    "trustees",
    "authorizers",
    "kyc",
    "aml",
  ],
  "government-body": ["personal", "business", "kyc", "aml"],
  "professional-body": [
    "personal",
    "business",
    "trustees",
    "authorizers",
    "kyc",
    "aml",
  ],
};

export const tabs = [
  { label: "PEP Report", key: "pep" },
  { label: "Sanction Report", key: "sanction" },
  { label: "Risk Report", key: "risk" },
];

export const sections = [
  { label: "Personal Information", key: "personal" },
  { label: "Business Information", key: "business" },
  { label: "Director's Information", key: "directors" },
  { label: "Shareholder's Information", key: "shareholders" },
  { label: "Trustee's Information", key: "trustees" },
  { label: "Authorizer's Information", key: "authorizers" },
  { label: "KYC Documents", key: "kyc" },
  { label: "AML Report", key: "aml" },
];

export const personalInformation = [
  { label: "First Name", key: "firstName", value: "" },
  { label: "Middle Name", key: "middleName", value: "" },
  { label: "Last Name", key: "lastName", value: "" },
  { label: "Phone Number", key: "phoneNumber", value: "" },
  { label: "Date of Birth", key: "dateOfBirth", value: "" },
  { label: "Gender", key: "gender", value: "" },
  { label: "Email", key: "email", value: "" },
  { label: "Nationality", key: "nationality", value: "" },
  { label: "Bank Verification Number", key: "bvnValid" },
  { label: "National Identification Number (NIN)", key: "nin", value: "" },
  { label: "Residential Address", key: "address", value: "" },
  { label: "Landmark", key: "landmark", value: "" },
  { label: "State of Origin", key: "state", value: "" },
  { label: "L.G.A of Origin", key: "localGovernment", value: "" },
  {
    label: "State of Residence",
    key: "stateOfResidence",
    value: "",
    type: "select",
  },
  {
    label: "L.G.A of Residence",
    key: "lgaOfResidence",
    value: "",
    type: "select",
  },

  {
    label: "Social Media Platform",
    key: "socialMediaPlatform",
    value: "",
    type: "select",
  },
  {
    label: "Social Media Handle",
    key: "socialMediaHandle",
    value: "",
  },
];

export const activationDetails = [
  { label: "Activated On", key: "activatedAt", value: "" },
  { label: "Activated By", key: "activitedBy", value: "" },
];

export const businessInformation = [
  { label: "Business Name", key: "businessName", value: "" },
  { label: "Email Address", key: "businessEmail", value: "" },
  { label: "Phone Number", key: "businessPhoneNumber", value: "" },
  { label: "RC Number", key: "rcNumber", value: "" },
  { label: "Business Address", key: "businessAddress", value: "" },
  { label: "Date of Incorporation", key: "registrationDate", value: "" },
  { label: "State", key: "businessState", type: "select", value: "" },
  { label: "L.G.A", key: "businessLGA", type: "select", value: "" },
  { label: "Business Category", key: "businessCategory", value: "" },
  {
    label: "Business Industry",
    key: "businessIndustry",
    type: "select",
    value: "",
  },
  { label: "Company Type", key: "businessType", type: "select", value: "" },
  {
    label: "Partnership Business",
    key: "isPartnershipBusiness",
    type: "select",
    value: "",
  },
];

export const allInformation = [
  { label: "First Name", key: "firstName" },
  { label: "Middle Name", key: "middleName" },
  { label: "Last Name", key: "lastName" },
  { label: "State of Origin", key: "state", value: "" },
  { label: "L.G.A", key: "lga", value: "" },
  { label: "Residential Address", key: "address" },
  { label: "Gender", key: "gender" },
  { label: "Bank Verification Number", key: "bvn" },
  { label: "Date of Birth", key: "dateOfBirth" },
  { label: "National Identification Number (NIN)", key: "nin" },
];

export const kycDocument = [
  { key: "_id" },
  { key: "name" },
  { key: "url" },
  { key: "agent" },
];

export const businessShareholder = [
  {
    label: "Image Link",
    key: "identification_information.image",
    disabled: true,
    view: true,
  },
  {
    label: "Full Name",
    key: "identification_information.full_name",
    disabled: true,
  },
  {
    label: "Country",
    key: "identification_information.country",
    disabled: true,
  },
  { label: "Gender", key: "identification_information.gender", disabled: true },
  {
    label: "Percentage Name Match",
    key: "identification_information.percentage_name_match",
    disabled: true,
  },
  { label: "Data Source", key: "data_source[0]", disabled: true },
];

export const sanctionInformation = [
  { label: "Business Name", key: "name" },
  {
    label: "Summary",
    key: "summary",
    disabled: true,
  },
  { label: "Type", key: "other_information.type", disabled: true },
  { label: "RC Number", key: "other_information.rc", disabled: true },
  {
    label: "Date of Registration",
    key: "other_information.date_of_registration",
    disabled: true,
  },
  {
    label: "Address",
    key: "other_information.address",
    disabled: true,
  },
  {
    label: "Reason",
    key: "other_information.reason_for_designation",
    disabled: true,
  },
];

export const personalDetails = [
  {
    label: "Full Name",
    key: "personal_details.name",
    disabled: true,
  },
  {
    label: "Image Link",
    key: "personal_details.image",
    disabled: true,
    view: true,
  },
  { label: "Gender", key: "personal_details.gender", disabled: true },
  { label: "Reference", key: "reference[0]", disabled: true, view: true },
  {
    label: "Country",
    key: "other_information.country",
    disabled: true,
  },
  {
    label: "Percentage Name Match",
    key: "percentage_name_match",
    disabled: true,
  },
];
